import React, { createContext, useContext, useState } from "react";

interface DialCodeType {
  value: string;
  label: string;
}

interface AuthContextType {
  mobile: string;
  setMobile: (val: string) => void;
  dialCode: DialCodeType;
  setDialCode: (val: DialCodeType) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [mobile, setMobile] = useState("7434960003");
  const [dialCode, setDialCode] = useState<DialCodeType>({
    value: "+971",
    label: "AE(+971)",
  });

  return (
    <AuthContext.Provider value={{ mobile, setMobile, dialCode, setDialCode }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context)
    throw new Error("useAuthContext must be used inside AuthProvider");
  return context;
};
